import { ZodIssueCode, type RefinementCtx } from 'zod';

import { IS_MEMBERSHIP_LIMIT_LESS_THAN_GLOBAL } from '@occc-app/lib/constants/validationMessages';

import { LimitTimePeriod } from '../types';

type ComparableMembershipGlobalLimit = {
  isEnabled?: boolean;
  limit?: number;
  timePeriod?: LimitTimePeriod;
};

export type ValidateMembershipLessThanGlobalParams = {
  membership: ComparableMembershipGlobalLimit;
  global: ComparableMembershipGlobalLimit;
  ctx: RefinementCtx;
};

export const validateMembershipLessThanGlobal = ({
  membership,
  global,
  ctx,
}: ValidateMembershipLessThanGlobalParams) => {
  const isMembershipEnabled = membership?.isEnabled ?? false;
  const isGlobalEnabled = global?.isEnabled ?? false;
  const membershipLimit = membership?.limit ?? 0;
  const globalLimit = global?.limit ?? 0;

  if (!isMembershipEnabled || !isGlobalEnabled) return;

  if (membership?.timePeriod === global?.timePeriod && membershipLimit >= globalLimit) {
    ctx.addIssue({
      code: ZodIssueCode.custom,
      message: IS_MEMBERSHIP_LIMIT_LESS_THAN_GLOBAL,
      path: ['membership', 'limit'],
    });
  }
};
